import React from 'react';
import './explore-srilanka.css';

function ExploreSrilanka() {
  // Sample data for locations
  const locations = [
    {
      id: 1,
      name: "Sigiriya",
      image: "/sigiriya.webp",
      description: "Ancient rock fortress with stunning frescoes and panoramic views",
      highlight: "UNESCO World Heritage Site"
    },
    {
      id: 2,
      name: "Yala National Park",
      image: "/yala.jpg",
      description: "Best place to spot leopards and diverse wildlife in their natural habitat",
      highlight: "Leopard Capital of the World"
    },
    {
      id: 3,
      name: "Waterfalls",
      image: "/waterfall.jpg",
      description: "Discover breathtaking waterfalls nestled in lush green mountains",
      highlight: "Over 100 majestic waterfalls"
    },
    {
      id: 4,
      name: "Mirissa",
      image: "/mirissa.jpg",
      description: "Pristine beaches and whale watching in the Indian Ocean",
      highlight: "Blue Whale Watching Capital"
    },
    {
      id: 5,
      name: "Ella",
      image: "/ellarock.jpg",
      description: "Mountain retreat with stunning views and hiking adventures",
      highlight: "Nine Arch Bridge & Little Adam's Peak"
    },
    {
      id: 6,
      name: "Anuradhapura",
      image: "/Anuradhapura.webp",
      description: "Sacred ancient city with well-preserved ruins and Buddhist temples",
      highlight: "First Ancient Capital of Sri Lanka"
    },
    {
      id: 7,
      name: "Colombo",
      image: "/colombo.webp",
      description: "Vibrant capital city blending colonial architecture with modern development",
      highlight: "Commercial Capital of Sri Lanka"
    },
    {
      id: 8,
      name: "Horton Plains",
      image: "/hortan p.jpg",
      description: "A breathtaking national park in Sri Lanka, famous for its cloud forests, grasslands, and dramatic escarpments like World's End. It’s home to rich biodiversity, rare wildlife, and scenic hiking trails.",
      highlight: "World's End & Scenic Hikes"
    },
    {
      id: 9,
      name: "Whale Watching",
      image: "/whale w.jpg",
      description: "A thrilling ocean adventure where visitors can witness the majestic blue whales, sperm whales, and playful dolphins in their natural habitat, mainly off the coast of Mirissa and Trincomalee.",
      highlight: "Blue Whales & Dolphins"
    },

  ];





   const ravanalocations = [
    { 
      name: "Ravana Cave", 
      img: "ravanacave.jpg", 
      desc: "The Ravana Cave, located near Ella, is one of the most fascinating historical sites tied to the Ramayana epic. Legends say this cave system was used by King Ravana himself to hide Princess Sita after her abduction. The caves stretch deep into the mountain, and their tunnels are believed to have connected to other parts of Ravana’s kingdom. Visitors standing here can feel the air of mystery and imagine the stories of a time when this was a secret passageway guarded by Ravana’s soldiers." 
    },
    { 
      name: "Ravana Waterfall", 
      img: "ravanawaterfall.jpg", 
      desc: "Ravana Falls, cascading from a height of 82 feet, is one of the widest waterfalls in Sri Lanka and is deeply connected to the Ramayana story. It is said that Princess Sita once bathed in the cool waters of this fall during her captivity. Surrounded by lush jungle, the falls create a mesmerizing view that blends myth with nature, making it a must-visit destination for anyone retracing the footsteps of the Ramayana." 
    },
    { 
      name: "Laggala", 
      img: "laggala.webp", 
      desc: "The village of Laggala is mentioned in the Ramayana as the place where Ravana’s majestic city once stood. It was here that King Ravana is said to have performed religious rituals and sought blessings before going into battle. Today, Laggala is surrounded by rugged cliffs and scenic landscapes, making it not only historically significant but also a breathtaking stop for those exploring Sri Lanka’s Ramayana trail." 
    },
    { 
      name: "Seetha Kotuwa", 
      img: "seetakotuwa.jpg", 
      desc: "Seetha Kotuwa, meaning 'Fort of Sita,' is believed to be the first place where Princess Sita was kept after her abduction by Ravana. The area was once a fortress surrounded by lush forests, streams, and waterfalls. Ancient ruins of this fortress can still be seen, telling the story of a kingdom that once flourished here. For Ramayana devotees, visiting Seetha Kotuwa is like stepping back into the heart of the epic itself." 
    },
    { 
      name: "Yahangala", 
      img: "yahangala.jpg", 
      desc: "Yahangala, also known as the 'Bedrock of Ravana,' is said to be the place where King Ravana’s body was laid to rest after his defeat by Lord Rama. The massive rock formation resembles a reclining figure, and local legends strongly tie it to the great king’s final moments. Surrounded by wild beauty, Yahangala is a place of reverence and awe for visitors seeking to connect with the Ramayana legend." 
    },
    { 
      name: "Dunuwila", 
      img: "dunuwila.jpg", 
      desc: "The tranquil village of Dunuwila carries a powerful legend from the Ramayana. It is said to be the exact spot where Lord Rama prepared his arrow and fired the Brahmastra, the divine weapon that struck down King Ravana. Today, the serene landscape and peaceful waters of Dunuwila create a stark contrast to the intense battle that once took place here, offering a place of reflection for visitors." 
    },
    { 
      name: "Dolukanda", 
      img: "dolukanda.JPG", 
      desc: "Dolukanda mountain is believed to be one of the places where fragments of the Sanjeevani mountain fell when Hanuman carried it from the Himalayas to save Lakshmana’s life. This site is still rich in medicinal plants and is treasured by locals for its healing herbs. For Ramayana followers, Dolukanda is a living reminder of Hanuman’s devotion and the divine powers described in the epic." 
    },
    { 
      name: "Seetha Amman Temple", 
      img: "seetatemple.jpg", 
      desc: "The Seetha Amman Temple in Nuwara Eliya is built at the very site where Princess Sita is believed to have prayed to Lord Rama during her captivity. The temple is adorned with colorful sculptures depicting scenes from the Ramayana, and nearby streams are said to bear the footprints of Hanuman. This sacred temple is an important place of worship for Hindu pilgrims and a serene spot for all visitors." 
    },
    { 
      name: "Ashoka Vatika", 
      img: "ashokawatika.jpg", 
      desc: "Ashoka Watika, the legendary garden where Princess Sita was kept under the watch of Ravana, is perhaps one of the most famous Ramayana sites in Sri Lanka. Surrounded by beautiful Ashoka trees, it is said that Sita spent her days here waiting for Lord Rama. Today, the site is filled with devotion and tranquility, allowing visitors to reflect on the enduring love and faith described in the epic." 
    },
  ];



  return (
    <div className="explore-srilanka-page">
      {/* Banner Section */}
      <div className="banner-container">
        <img 
          src="explore srilanka.png" 
          alt="Explore Sri Lanka" 
          className="banner-image"
        />

      </div>

      {/* Introduction Section */}
      <div className="intro-section">
        <h2>Why Visit Sri Lanka?</h2>
        <p>Sri Lanka offers an incredible diversity of experiences in a compact island setting. From ancient UNESCO World Heritage sites to pristine beaches, wildlife safaris to lush tea plantations, this tropical paradise promises unforgettable memories for every traveler.</p>
      </div>

      {/* Locations Grid */}




 <div className="locations-container">
      <h2>Must-Visit Destinations of the Ramayana Trail</h2>
      <div className="locations-grid">
        {ravanalocations.map((loc, index) => (
          <div key={index} className="location-card">
            <img src={`/${loc.img}`} alt={loc.name} className="location-img" />
            <h3>{loc.name}</h3>
            <p className="location-desc">{loc.desc}</p>
          </div>
        ))}
      </div>
    </div>


      <div className="locations-container">
        <h2>Must-Visit Destinations</h2>
        <div className="locations-grid">
          {locations.map(location => (
            <div key={location.id} className="location-card">
              <div className="location-image-container">
                <img src={location.image} alt={location.name} />
    
              </div>
              <div className="location-info">
                <h3>{location.name}</h3>
                <p>{location.description}</p>
                <span className="highlight">{location.highlight}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action */}
      {/* <div className="cta-section">
        <h2>Ready for Your Sri Lankan Adventure?</h2>
        <p>Plan your trip to experience the rich culture, breathtaking landscapes, and warm hospitality of Sri Lanka</p>
        
        <a href="https://www.chavotours.lk" target="_blank" rel="noopener noreferrer">
            <button className="cta-button">Start Planning Now</button>
          </a>

      </div> */}
      
    </div>
  );
}

export default ExploreSrilanka;